import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SuccessMessage } from '../models/successMessage';
@Injectable({
  providedIn: 'root'
})
export class ChecklistService {

  O3CoreApiUrl: any = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }
  getTypes(): Observable<any> {
    // return this.http.get<any>(this.baseUrl + 'qualitytypes');
    return this.http.get<any>(this.O3CoreApiUrl + 'QualityTypes/GetAllQualityTypes');

  }
  getItemTypes(): Observable<any> {
    // return this.http.get<any>(this.baseUrl + 'itemtypes');
    return this.http.get<any>(this.O3CoreApiUrl + 'QualityTypes/GetItemTypes');

  }
  getCheckList(data: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'allqualitychecklists', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'QualityChecklist/GetAllQualityCheckLists', data);
  }

  getCheckListById(checkList: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'qualitychecklist', checkList);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/GetQualityCheckListById', checkList);
  }

  addCheckListdata(checkList: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'addqualitychecklist', checkList);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/AddNewQualityCheckList', checkList);

  }
  addBulkCheckListdata(checkList: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'addqualitychecklist', checkList);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/AddBulkQualityCheckList', checkList);

  }

  updateCheckListdata(checkList: any): Observable<any[]> {
    //return this.http.put<any[]>(this.baseUrl + 'qualitychecklist', checkList);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/UpdateNewQualityCheckList', checkList);
  }
  deletechecklist(data: any): Observable<SuccessMessage> {
    //return this.http.post<SuccessMessage>(this.baseUrl + 'deletequalitychecklist', data);
    return this.http.post<SuccessMessage>(this.O3CoreApiUrl + 'QualityChecklist/DeleteQualityList', data);

  }

  saveCheckListType(data: any) {
    //return this.http.post(this.baseUrl + 'createQualityType', data);
    return this.http.post(this.O3CoreApiUrl + 'QualityTypes/CreateQualityType', data);
  }

  editCheckListType(data: any) {
    //return this.http.post(this.baseUrl + 'updateQualityTypes', data);
    return this.http.post(this.O3CoreApiUrl + 'QualityTypes/UpdateQualityTypes', data);
  }

  deleteCheckListType(data: any) {
    // return this.http.post(this.baseUrl + 'deleteQualityTypes', data);
    return this.http.post(this.O3CoreApiUrl + 'QualityTypes/DeleteQualityTypes', data);
  }

  GetChecklistExecutionImages(data: any) {
    return this.http.post(this.O3CoreApiUrl + 'QualityCheckExecution/GetChecklistExecutionImages', data);
  }

  GetHearderAndSubHeader(data: any): Observable<any> {
    return this.http.post(this.O3CoreApiUrl + 'CheckListHeaderFooter/GetHearderAndSubHeader', data);
  }

  GetCheckListReport(data: any): Observable<any> {
    return this.http.post(this.O3CoreApiUrl + 'CheckListHeaderFooter/GetCheckListReport', data);
  }

  UpdateChecklistHeaderSubHeader(data: any) {
    return this.http.post(this.O3CoreApiUrl + 'CheckListHeaderFooter/UpdateChecklistHeaderSubHeader', data);
  }

  getTypesByPlant(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'QualityTypes/GetAllQualityTypes', data);
  }

  getCheckListforQualityType(data: any) {
    return this.http.post(this.O3CoreApiUrl + 'QualityTypes/GetQualityTypesbyChecklist', data);
  }

  DuplicateChecklist(data: any) {
    return this.http.post(this.O3CoreApiUrl + 'QualityChecklist/DuplicateCheckList', data);
  }
  CheckList_CRUD_HeaderFooterConfiguration(data: any) {
    return this.http.post(this.O3CoreApiUrl + 'CheckListHeaderFooter/CheckList_CRUD_HeaderFooterConfiguration', data);
  }

  deleteItemdropdown(data: any) {
    return this.http.post(this.O3CoreApiUrl + 'QualityChecklist/DeleteDropdownElement', data);
  }

  getdropdowndatabyId(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'QualityCheckList/GetdropdowndatabyDetailId', data)
  }

  savedropdownitem(data: any) {
    return this.http.post(this.O3CoreApiUrl + 'QualityChecklist/SaveDropDownItem', data);
  }

  getHearderAndSubHeader(data: any) {
    return this.http.post(this.O3CoreApiUrl + 'CheckListHeaderFooter/GetHearderAndSubHeader', data);
  }

  getCheckListFlag(data: any) {
    return this.http.post(this.O3CoreApiUrl + 'QualityCheckList/GetCheckListFlag', data);
  }
  getChecklistHistory(checkListId: any): Observable<any> {
    return this.http.post(this.O3CoreApiUrl + 'QualityCheckList/GetChecklistHistory', checkListId);
  }

  getChecklistHistoryDetails(checkListDetailIds: string): Observable<any> {
    return this.http.post(this.O3CoreApiUrl + 'QualityCheckList/GetChecklistHistoryDetails', {
      checkListDetailIds: checkListDetailIds
    });
  }

}
